// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__EeBKj","close":"Modal_close__nnot4"};